import * as consts from './AppConsts';

const initialState = {
    tourId: 0,
    tourType: '',
    getTourFulfilled: false,
    getTourError: '',
    fullscreenEnabled: false,
    contentBlur: 0,
    isDrafted: false,
    isLogined: false
};

const app = (state = initialState, action) => {
    switch (action.type) {
        case consts.CHANGE_FULLSCREEN:
            return {
                ...state,
                fullscreenEnabled: action.payload
            }
        case consts.SET_URL_PARAMS:
            return {
                ...state,
                tourId: action.payload.tourId,
                tourType: action.payload.tourType
            }
        case consts.GET_TOUR_PENDING:
            return {
                ...state,
                getTourFulfilled: false
            }
        case consts.GET_TOUR_REJECTED:
            return {
                ...state,
                getTourFulfilled: true
            }
        case consts.SET_CONTENT_BLUR:
            return {
                ...state,
                contentBlur: action.payload
            }
        default:
            return state
    }
}

export default app;
